import { useMemo } from 'react';
import { Box } from '@mui/material';
import { FileList } from 'entities/files/file-list';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';
import { useFileList } from 'entities/files/file-list.hook';
import { FileListFilter } from 'features/files/file-filter';

export const FilesList = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getFilesRelatedSearchParams = useMemo(() => {
    const relatedFields = ['uploadedById', 'createdAtFrom', 'createdAtTo', 'mimetype'];
    const newParams = new URLSearchParams();
    [...searchParams.entries()].forEach(([key, value]) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    return newParams;
  }, [searchParams]);

  const collection =  useFileList(paging, getFilesRelatedSearchParams);

  return (
    <Box mt={2}>
      <Box mb={1}>
        <FileListFilter />
      </Box>

      <FileList collection={collection} paging={paging} onChangePaging={setPaging} />
    </Box>
  );
};
